var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 48,
    viewBox: "0 0 67 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 48,
    rx: 21,
    fill: "#34C759"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.206 28.4857C32.1677 31.5983 35.7648 34 38.706 34C40.028 34 41.1861 33.5153 42.1187 32.4383C42.6618 31.8029 43 31.0598 43 30.3274C43 29.7889 42.8053 29.2719 42.3236 28.9058L39.1775 26.5579C38.6958 26.2132 38.2961 26.0409 37.9272 26.0409C37.466 26.0409 37.0458 26.3209 36.5744 26.8056L35.8468 27.5595C35.7341 27.678 35.5906 27.7318 35.4574 27.7318C35.3037 27.7318 35.1499 27.6672 35.0475 27.6134C34.4121 27.2579 33.3258 26.2779 32.3112 25.2224C31.3069 24.1669 30.3743 23.0253 30.0464 22.3576C29.9951 22.2391 29.9337 22.0883 29.9337 21.9268C29.9337 21.7868 29.9746 21.6467 30.0874 21.5283L30.815 20.7421C31.2659 20.2466 31.5426 19.8158 31.5426 19.3204C31.5426 18.9327 31.3684 18.5127 31.0302 18.0065L28.8269 14.7431C28.4682 14.2262 27.966 14 27.4126 14C26.7362 14 26.0394 14.3231 25.4347 14.937C24.4407 15.9386 24 17.1772 24 18.545C24 21.636 26.2443 25.384 29.206 28.4857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.3a163d3d91845c677118e5736f3a44b4.svg";
export { ForwardRef as ReactComponent };